import React from "react";
import TrDateInput from "@/components/TrDateInput";

const CLS = "w-full px-2.5 py-1.5 text-sm bg-white dark:bg-slate-800/70 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500";

export function TrDateField({ label, value, onChange, testid }) {
  return (
    <label className="block">
      {label && <span className="text-xs font-medium uppercase tracking-wider text-slate-500 dark:text-slate-400 block mb-1">{label}</span>}
      <TrDateInput value={value || ""} onChange={onChange} className={CLS} data-testid={testid} />
    </label>
  );
}
